<h2 mat-dialog-title>Upload Rock Image</h2>

<mat-dialog-content>
  <form [formGroup]="uploadForm" class="upload-form">
    <div class="input-row">
      <span>File Format</span>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>File Format</mat-label>
        <mat-select formControlName="fileFormat">
          <mat-option value="raw">RAW</mat-option>
          <mat-option value="ibf">IBF</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="input-row">
      <span>{{isIbfFormat() ? 'IBF File' : 'Zip File'}}</span>
      <div class="flex">
        <input
          type="file"
          #fileInput
          [accept]="isIbfFormat() ? '.ibf' : '.zip'"
          (change)="onFileSelected($event)"
          style="display: none"
        />
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Selected File</mat-label>
          <input matInput [value]="(selectedFileName! | removeExtension) || ''" readonly />
        </mat-form-field>
        <button
          type="button"
          class="btn btn-primary upload-btn"
          (click)="fileInput.click()"
        >
          <mat-icon>search</mat-icon>
        </button>
      </div>
      @if (uploadForm.get('file')?.invalid && uploadForm.get('file')?.touched) {
        <span class="error-message">File is required</span>
      }
      @if (fileError) {
        <span class="error-message">{{ fileError }}</span>
      }
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Data Type</mat-label>
      <mat-select formControlName="dataType">
        <mat-option value="uint8">uint8</mat-option>
        <mat-option value="uint16">uint16</mat-option>
      </mat-select>
      @if (uploadForm.get('dataType')?.invalid) {
        <mat-error>Data type is required</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Resolution (μm/voxel)</mat-label>
      <input
        matInput
        type="number"
        formControlName="resolution"
        step="0.0001"
        min="0.0001"
        placeholder="Enter positive decimal number"
      />
      @if (uploadForm.get('resolution')?.invalid) {
        <mat-error>Resolution must be a positive decimal number</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Voxels X</mat-label>
      <input
        matInput
        type="number"
        formControlName="voxelsX"
        min="1"
        step="1"
        placeholder="Enter positive integer"
      />
      @if (uploadForm.get('voxelsX')?.invalid) {
        <mat-error>Voxels X must be a positive integer</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Voxels Y</mat-label>
      <input
        matInput
        type="number"
        formControlName="voxelsY"
        min="1"
        step="1"
        placeholder="Enter positive integer"
      />
      @if (uploadForm.get('voxelsY')?.invalid) {
        <mat-error>Voxels Y must be a positive integer</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Voxels Z</mat-label>
      <input
        matInput
        type="number"
        formControlName="voxelsZ"
        min="1"
        step="1"
        placeholder="Enter positive integer"
      />
      @if (uploadForm.get('voxelsZ')?.invalid) {
        <mat-error>Voxels Z must be a positive integer</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="btn btn-secondary" (click)="onCancel()">
    Cancel
  </button>
  <button class="btn btn-primary" (click)="onConfirm()" [disabled]="uploadForm.invalid || !!fileError">
    Upload
  </button>
</mat-dialog-actions>
